import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Grid,
  Icon,
  HStack,
} from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons";
import React from "react";

const PremiumList = () => {
  return (
    <Box bg="black" minH={{ base: "100vh", lg: "80vh" }} pt={12}>
      <Container maxW="container.md">
        <VStack spacing={6} color="white">
          <Heading textAlign="center" size="xl" lineHeight={1.2}>
            Freedom to cancel anytime!
          </Heading>

          <Text>Get full access with Premium!</Text>
          <Box
            fontSize={"md"}
            // bg="rgba(255, 255, 255, 0.05)"
            w="full"
            p={8}
            borderRadius="xl"
          >
            <Grid templateColumns="repeat(3, 1fr)" gap={4} position="relative">
              <Box
                right="6"
                top={"-3rem"}
                borderRadius={"2rem"}
                width={[0, 0, "10rem"]}
                bottom={"-3rem"}
                position={"absolute"}
                bg={"whiteAlpha.200"}
                zIndex={0}
              ></Box>
              <Text fontWeight="bold">Features</Text>
              <Text fontWeight="bold" textAlign="center">
                FREE
              </Text>
              <HStack zIndex={100} justify="center">
                <Text
                  bg="linear-gradient(90deg, #FF6B6B 0%,  #4ECDC4 100%)"
                  bgClip="text"
                  fontWeight="bold"
                >
                  PREMIUM
                </Text>
              </HStack>
              {[
                "Introductory Lessons",
                "Complete Courses",
                "Guided Learning Paths",
                "Advanced Lessons",
              ].map((feature, index) => (
                <React.Fragment key={index}>
                  <Text mt={"1rem"} key={feature}>
                    {feature}
                  </Text>
                  <Box textAlign="center">
                    {index === 0 && <Icon as={CheckIcon} color="white" />}
                    {index !== 0 && <Text color="gray.500">—</Text>}
                  </Box>
                  <Box zIndex={100} textAlign="center">
                    <Icon as={CheckIcon} color="white" />
                  </Box>
                </React.Fragment>
              ))}
            </Grid>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default PremiumList;
